var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmailCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 77,
    viewBox: "0 0 78 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.314941,
    width: 77,
    height: 77,
    rx: 38.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.2962 22.144L38.9478 32.365L26.3171 22.144V22.1468L26.3324 22.1606V36.4727L38.8055 46.9145L51.2962 36.8759V22.144Z",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5375 19.6577L51.2947 22.1439V36.8758L61.4989 28.5666V23.561C61.4989 23.561 60.2604 16.4119 54.5375 19.6577Z",
    fill: "#FBBC05"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2947 36.8756V55.9832H59.1157C59.1157 55.9832 61.3413 55.7402 61.5014 53.0496V28.5664L51.2947 36.8756Z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3335 56.0004V36.4728L26.3171 36.459L26.3335 56.0004Z",
    fill: "#C5221F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3165 22.1464L23.0914 19.6741C17.3686 16.4282 16.1274 23.5746 16.1274 23.5746V28.58L26.3165 36.4585V22.1464Z",
    fill: "#C5221F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3171 22.147V36.4591L26.3335 36.4729V22.1608L26.3171 22.147Z",
    fill: "#C5221F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1274 28.5835V53.0666C16.2851 55.7601 18.5132 56.0005 18.5132 56.0005H26.3343L26.3165 36.4592L16.1274 28.5835Z",
    fill: "#4285F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmailCircle);
export default __webpack_public_path__ + "static/media/gmailCircle.b1c36b7a46a2935e82375c0adf9f8259.svg";
export { ForwardRef as ReactComponent };